import(/* webpackMode: "eager" */ "/home/jetrails/uk.awbridal.com/html/node_modules/.pnpm/next@14.2.35_@babel+core@7.26.10_react-dom@18.2.0_react@18.2.0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/uk.awbridal.com/html/src/components/attire-page/client-top-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/uk.awbridal.com/html/src/components/attire-page/product-slider.jsx");
;
import(/* webpackMode: "eager" */ "/home/jetrails/uk.awbridal.com/html/src/components/hover-prefetch-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jetrails/uk.awbridal.com/html/src/components/shop-by-colors-family.tsx");
